import { handleRequest } from "../utilities/requestHandler";

export const getSitesByCustomerID = (customerId) =>
    handleRequest("get",`/cus_sites/getsites/${customerId}`);

export const getMachinesBySiteId = (siteNumber) =>
    handleRequest("post","/machines/bysiteid",{site_number:siteNumber});

export const getProvisionedMachines = ({ includeInactive } = {}) => {
    const params = new URLSearchParams();
    if (includeInactive) params.set("include_inactive", "true");
    const query = params.toString();
    const url = query ? `/machines/by-provision?${query}` : "/machines/by-provision";
    return handleRequest("get", url);
};

export const provisionMachinesForCustomerSite = (req_body) =>
    handleRequest("post","/cus_sites/provisionmachines",{table_data: req_body});

export const deleteProvisionsForCustomerSite = (req_body) =>
    handleRequest("post", "/cus_sites/delete-provisions", req_body);

export const updateProvisionForCustomerSite = (id, data) =>
    handleRequest("put", `/cus_sites/provisions/${id}`, data);
